import React, { useState, useEffect } from "react";
import { baseUrl } from "../../../../services/config";
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";
import { Field, useFormik, Form, Formik, FieldArray } from "formik";
import * as Yup from "yup";
import { Col } from "react-bootstrap";
import { Table, Modal, Alert } from "react-bootstrap";
import {
  Input,
  DatePickerField,
  Select,
} from "../../../../_metronic/_partials/controls";
import { values } from "lodash-es";

const EditDefineSallary = ({ staffDetails, salaryExtraData, show, reload }) => {
  const alert = useAlert();
  const authtoken = localStorage.getItem("userToken");

  const [loading, setloading] = useState(false);
  const [designation_id, setdesignation_id] = useState(
    staffDetails.designation_id,
  );
  const [pay_scale_id, setpay_scale_id] = useState(staffDetails.pay_scale_id);
  const [qualification, setqualification] = useState(
    staffDetails.qualification,
  );
  const [account_no, setaccount_no] = useState(staffDetails.account_no);
  const [global_bank_id, setglobal_bank_id] = useState(
    staffDetails.global_bank_id,
  );

  const [isPreviewEnable, setisPreviewEnable] = useState(false);
  const [previewValue, setpreviewValue] = useState({});
  const [salery_days, setsalery_days] = useState(staffDetails.salery_days);
  const [payment_type, setpayment_type] = useState(staffDetails.payment_type);
  const [hifz, sethifz] = useState("");
  const [hostel, sethostel] = useState("");
  const [college, setcollege] = useState("");
  const [additional, setadditional] = useState("");
  const [increment, setincrement] = useState("");
  const [second_shift, setsecond_shift] = useState("");
  const [ugs, setugs] = useState("");
  const [other, setother] = useState("");
  const [hod, sethod] = useState("");
  const [science, setscience] = useState("");
  const [extra_period, setextra_period] = useState("");
  const [extra_coaching, setextra_coaching] = useState("");
  const [convance, setconvance] = useState("");
  const [eobi, seteobi] = useState("");
  const [income_tax, setincome_tax] = useState("");
  const [insurance, setinsurance] = useState("");
  const [van_charge, setvan_charge] = useState("");

  const [otherallowance, setotherallowance] = useState("");
  const [designations, setdesignations] = useState([]);
  const [AllPayScales, setAllPayScales] = useState([]);
  const [bankList, setbankList] = useState([]);
  const [showerr, setshowerr] = useState(false);
  const [showerror, setshowerror] = useState("Please Fill all Fields");
  const [alreadygeneratedsalary, setalreadygeneratedsalary] = useState({});

  const [allsubaccounts, setallsubaccounts] = useState([]);
  //   const [selectedbankcateogry, setselectedbankcateogry] = useState([]);
  const [selectedBankCateogry, setSelectedBankCateogry] = useState(
    staffDetails.bank_account_id,
  );
  const [selectedBank, setSelectedBank] = useState([]);
  const [extrasData, setExtrasData] = useState([]);
  const [resetCheck, setResetCheck] = useState(false);

  // initialValues=  {
  //   issubmitted: false,

  //   // designation_id: staffDetails.designation_id,
  //   pay_scale_id: staffDetails.pay_scale_id == null ? "" : staffDetails.pay_scale_id,
  //   // qualification: staffDetails.qualification,
  //   // account_no: staffDetails.account_no,

  //   // global_bank_id: staffDetails.global_bank_id,
  //   // salery_days: staffDetails.salery_days,
  //   // payment_type: staffDetails.payment_type,
  //   hifz: "",

  //   hostel: "",
  //   college: "",
  //   additional_allowance: "",
  //   increment: "",

  //   second_shift: "",
  //   ugs: "",
  //   hod: "",
  //   other_allowance: "",

  //   science: "",
  //   extra_period: "",
  //   extra_coaching: "",
  //   convance: "",

  //   eobi: "",
  //   income_tax: "",
  //   insurance: "",
  //   van_charge: "",
  //   other: "",
  // }

  let initialValues = {
    issubmitted: false,

    basic: staffDetails.basic_pay,
    salary_month: staffDetails.salary_month,
    id: staffDetails.id,

    extras: staffDetails?.employee_salary_extras || [],

    gp_fund: staffDetails.gp_fund,
    gpf_return: staffDetails.gpf_return,
    welfare_fund: staffDetails.welfare_fund,
    days: staffDetails.days,
    loan_refund: staffDetails.loan_refund,
    // reset: resetCheck,
  };

  useEffect(() => {
    getSalaryDetail();
    getAlldesignations();
    getAllPayScales();
    getAllBankList();
  }, []);

  const getSalaryDetail = () => {
    fetch(`${baseUrl}/emp-salary-detail/${staffDetails.employee_id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            setalreadygeneratedsalary(data.payload?.employee);
            setExtrasData(data?.payload?.employee_salary_extras);
          } else {
          }
        } else {
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAlldesignations = () => {
    fetch(`${baseUrl}/designations`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setdesignations(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const gotoTop = () => {
    window.scrollTo(0, 0);
  };

  const getAllPayScales = () => {
    fetch(`${baseUrl}/payscales`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setAllPayScales(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getAllBankList = () => {
    fetch(`${baseUrl}/bank_account_category`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setbankList(data.payload);

        let mainBank = 0;

        if (selectedBankCateogry ?? false) {
          data.payload.map((item, index) => {
            item.bank_accounts.map((subitem, index) => {
              if (subitem.id == selectedBankCateogry) {
                setSelectedBank(subitem.bank_account_category_id);
                mainBank = subitem.bank_account_category_id;
              }
            });
          });
        }

        if (mainBank != 0) {
          let bankData = data.payload.filter((item) => item.id == mainBank);

          if (bankData.length != 0) {
            setallsubaccounts([...bankData[0].bank_accounts]);
            // setallsubaccounts(initialValues.bank_account_id);
          } else {
            setallsubaccounts([]);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateHandler = (values) => {
    setloading(true);

    const filteredExtras = values.extras
      ?.filter((item) => item?.value && parseInt(item.value) > 0)
      ?.map((item) => ({
        employee_defined_extra_id: item.employee_defined_extra_id,
        value: item.value,
        salary_extra_id: item.employee_defined_extras?.salary_extra_id,
        name: item.employee_defined_extras?.salary_extras?.name,
        is_deduction: item.employee_defined_extras?.salary_extras?.is_deduction,
      }));

    const data = {
      id: staffDetails.id,
      basic_pay: values.basic == "" ? 0 : parseInt(values.basic),
      ...(filteredExtras.length > 0 && { extras: filteredExtras }),
      gp_fund: values.gp_fund,
      gpf_return: parseInt(values.gpf_return),
      welfare_fund: values.welfare_fund,
      days: values.days,
      loan_refund: values.loan_refund,
      preview: 0,
      bank_account_id: parseInt(selectedBankCateogry),
      reset: resetCheck == false ? 0 : 1,
    };

    fetch(`${baseUrl}/employeeSalary_update`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        res.json().then((data) => {
          setloading(false);
          show(false);
          if (data.metadata) {
            if (data.metadata.success) {
              alert.success("Salary Updated Successfully");
              setloading(false);
              show(false);
              reload();
            } else {
              show(false);
              setloading(false);
              const msgArray = Object.values(data.metadata.message);
              msgArray.map((err) => alert.error(err[0]));
            }
          } else {
            show(false);
            setloading(false);
          }
        });
      })
      .catch((err) => {
        console.log(err);
        setloading(false);
        alert.error(err);
        show(false);
      });
  };

  //start here

  const AppointStaffSchema = Yup.object().shape({
    basic: Yup.string()
      .notRequired("Hifz  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),

    extras: Yup.array().of(
      Yup.object().shape({
        value: Yup.string()
          .required("Value is required")
          .matches(/^[0-9\b]+$/, "Should be a valid number"),
      }),
    ),

    welfare_fund: Yup.string()
      .notRequired("Welfare Fund  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    gp_fund: Yup.string()
      .notRequired("GP Fund  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    gpf_return: Yup.string()
      .notRequired("GP Fund Return  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    loan_refund: Yup.string()
      .notRequired("Loan Refund Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
  });

  const createEroors = (errors, touched, isSubmitting, values) => {
    setshowerr(false);

    if (Object.keys(errors).length === 0) {
      if (isSubmitting) {
        if (!values.issubmitted) {
          values.issubmitted = true;
          updateHandler(values);
        }
      }
    }
  };

  const previewHandle = (values) => {
    setisPreviewEnable(true);

    const filteredExtras = values.extras
      ?.filter((item) => item?.value && parseInt(item.value) > 0)
      ?.map((item) => ({
        employee_defined_extra_id: item.employee_defined_extra_id,
        value: item.value,
        salary_extra_id: item.employee_defined_extras?.salary_extra_id,
        name: item.employee_defined_extras?.salary_extras?.name,
        is_deduction: item.employee_defined_extras?.salary_extras?.is_deduction,
      }));

    const data = {
      id: staffDetails.id,
      basic_pay: values.basic == "" ? 0 : parseInt(values.basic),
      ...(filteredExtras.length > 0 && { extras: filteredExtras }),
      gp_fund: values.gp_fund,
      gpf_return: values.gpf_return,
      welfare_fund: values.welfare_fund,
      days: values.days,
      loan_refund: values.loan_refund,
      preview: 1,
      bank_account_id: parseInt(selectedBankCateogry),
      reset: resetCheck == false ? 0 : 1,
    };

    fetch(`${baseUrl}/employeeSalary_update`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        res.json().then((data) => {
          const obj = {
            net_pay: data.payload.net_pay,
            gross_salary: data.payload.gross_salary,
          };
          setpreviewValue(obj);
        });
      })
      .catch((err) => {
        console.log(err);
        alert.error(err);
        show(false);
      });
  };

  return (
    <div>
      {loading ? (
        <b style={{ color: "green" }}>
          Salary updating Please Wait <span className="spinner-borderd"></span>
        </b>
      ) : (
        <div>
          <div class="container-fluid">
            <div class="row d-flex justify-content-center ">
              <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                <div>
                  <Formik
                    enableReinitialize={true}
                    initialValues={initialValues}
                    validationSchema={AppointStaffSchema}
                    onSubmit={(values) => {
                      // updateHandler(values);
                    }}
                  >
                    {(props) => {
                      const {
                        handleSubmit,
                        errors,
                        touched,
                        values,
                        isSubmitting,
                        isValid,
                        handleChange,
                        handleBlur,
                      } = props;

                      // setErrorsLis(errors)
                      createEroors(errors, touched, isSubmitting, values);

                      return (
                        <>
                          <Form
                            onSubmit={handleSubmit}
                            className="form form-label-right"
                          >
                            <h3 className="m-3"> Salary Allowance</h3>
                            <FieldArray name="extras">
                              {() => (
                                <div className="row text-left">
                                  <div class="form-group col-sm-4 flex-column d-flex">
                                    <label class="form-control-label">
                                      <b>
                                        Basic Salary
                                        <span style={{ color: "red" }}>*</span>
                                      </b>
                                    </label>
                                    <Field
                                      name="basic"
                                      component={Input}
                                      placeholder="Basic Salary"
                                    />
                                  </div>

                                  {values.extras?.map((extra, index) => {
                                    if (
                                      extra?.employee_defined_extras
                                        ?.salary_extras?.is_deduction != 1
                                    ) {
                                      return (
                                        <div
                                          key={index}
                                          className="form-group col-sm-4 flex-column d-flex"
                                        >
                                          <label className="form-control-label">
                                            <b>
                                              {
                                                extra?.employee_defined_extras
                                                  ?.salary_extras?.name
                                              }
                                            </b>
                                          </label>
                                          <Field
                                            name={`extras[${index}].value`}
                                            component={Input}
                                            type="number"
                                            placeholder={
                                              extra?.employee_defined_extras
                                                ?.salary_extras?.name
                                            }
                                          />
                                        </div>
                                      );
                                    }
                                    return null;
                                  })}

                                  <div class="form-group col-sm-4 flex-column d-flex">
                                    <label class="form-control-label">
                                      <b>
                                        Days{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </b>
                                    </label>
                                    <Field
                                      name="days"
                                      component={Input}
                                      placeholder="Enter Days"
                                    />
                                  </div>
                                </div>
                              )}
                            </FieldArray>

                            <h3 className="m-3">Salary Deduction Details</h3>

                            <FieldArray name="extras">
                              {() => (
                                <div className="row text-left">
                                  {values.extras?.map((extra, index) => {
                                    if (
                                      extra?.employee_defined_extras
                                        ?.salary_extras?.is_deduction == 1
                                    ) {
                                      return (
                                        <div
                                          key={index}
                                          className="form-group col-sm-4 flex-column d-flex"
                                        >
                                          <label className="form-control-label">
                                            <b>
                                              {
                                                extra?.employee_defined_extras
                                                  ?.salary_extras?.name
                                              }
                                            </b>
                                          </label>
                                          <Field
                                            name={`extras[${index}].value`}
                                            component={Input}
                                            type="number"
                                            placeholder={
                                              extra?.employee_defined_extras
                                                ?.salary_extras?.name
                                            }
                                          />
                                        </div>
                                      );
                                    }
                                    return null;
                                  })}

                                  <div class="form-group col-sm-4 flex-column d-flex">
                                    <label class="form-control-label">
                                      <b>
                                        Gp Fund{" "}
                                        <span style={{ color: "red" }}>*</span>{" "}
                                      </b>
                                    </label>
                                    <Field
                                      name="gp_fund"
                                      component={Input}
                                      placeholder="Gp Fund"
                                    />
                                  </div>
                                  <div class="form-group col-sm-4 flex-column d-flex">
                                    <label class="form-control-label">
                                      <b>
                                        Gp Fund Return{" "}
                                        <span style={{ color: "red" }}>*</span>{" "}
                                      </b>
                                    </label>
                                    <Field
                                      name="gpf_return"
                                      component={Input}
                                      placeholder="Gp Fund Return"
                                    />
                                  </div>

                                  <div class="form-group col-sm-4 flex-column d-flex">
                                    <label class="form-control-label">
                                      <b>
                                        Welfare Fund{" "}
                                        <span style={{ color: "red" }}>*</span>{" "}
                                      </b>
                                    </label>
                                    <Field
                                      name="welfare_fund"
                                      component={Input}
                                      placeholder="Welfare Fund"
                                    />
                                  </div>
                                  <div class="form-group col-sm-4 flex-column d-flex">
                                    <label class="form-control-label">
                                      <b>
                                        Loan Refund{" "}
                                        <span style={{ color: "red" }}>*</span>{" "}
                                      </b>
                                    </label>
                                    <Field
                                      name="loan_refund"
                                      component={Input}
                                      placeholder="Loan Refund"
                                    />
                                  </div>
                                </div>
                              )}
                            </FieldArray>

                            <div class="row justify-content-between text-left">
                              <div class="form-group col-sm-6 flex-column d-flex">
                                <label class="form-control-label">
                                  <b>
                                    Select Bank
                                    <span
                                      style={{ color: "red", fontSize: 12 }}
                                    >
                                      *
                                    </span>
                                  </b>
                                </label>
                                <select
                                  className="form-select form-control"
                                  name="sub_account_id"
                                  value={selectedBank}
                                  onChange={(e) => {
                                    setSelectedBank(e.target.value);

                                    let bankData = bankList.filter(
                                      (item) => item.id == e.target.value,
                                    );

                                    if (bankData.length != 0) {
                                      setallsubaccounts([
                                        ...bankData[0].bank_accounts,
                                      ]);
                                    } else {
                                      setallsubaccounts([]);
                                    }
                                  }}
                                  style={{ backgroundColor: "white" }}
                                  aria-label="Default select example"
                                >
                                  <option acode="" selected value="">
                                    Select...
                                  </option>
                                  {bankList.map((item) => (
                                    <option value={item.id}>
                                      {item.title}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div class="form-group col-sm-6 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Select Bank Branch
                                    <span style={{ color: "red" }}>*</span>
                                  </b>
                                </label>
                                <select
                                  className="form-select form-control"
                                  name="sub_account_id"
                                  value={selectedBankCateogry}
                                  onChange={(e) => {
                                    setSelectedBankCateogry(e.target.value);
                                  }}
                                  style={{ backgroundColor: "white" }}
                                  aria-label="Default select example"
                                >
                                  <option acode="" selected value="">
                                    Select...
                                  </option>
                                  {allsubaccounts.map((item) => (
                                    <option value={item.id}>
                                      {item.bank_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </Form>
                          {isPreviewEnable ? (
                            <div className="row m-3">
                              <h4>Net Pay: {previewValue.net_pay}</h4>
                              <h4>Gross Salary: {previewValue.gross_salary}</h4>
                            </div>
                          ) : null}
                          {showerr ? (
                            <div id="err">
                              <Alert
                                variant="danger"
                                onClose={() => setshowerr(false)}
                                dismissible
                              >
                                <Alert.Heading>
                                  Oops You Got an Error!
                                </Alert.Heading>
                                <p>{showerror}</p>
                              </Alert>
                            </div>
                          ) : null}
                          <div className="row justify-content-between mb-4">
                            <div className="col-md-6">
                              <button
                                type="submit"
                                value="Submit"
                                onClick={() => previewHandle(values)}
                                className="btn btn-primary pl-4 pr-4"
                              >
                                Preview Salary
                              </button>
                            </div>
                            <div className="col-md-6">
                              <label className="checkbox checkbox-single">
                                <input
                                  name="reset_checkbox"
                                  type="checkbox"
                                  onChange={(e) =>
                                    setResetCheck(e.target.checked)
                                  }
                                />
                                <span />
                                &nbsp;&nbsp;&nbsp;Reset Salary to Defined Actual
                                Amount
                              </label>
                            </div>
                          </div>
                          <div class="btns flex_last">
                            <button
                              type="submit"
                              value="Submit"
                              onClick={() => handleSubmit()}
                              //   onClick={updateHandler}
                              class="btn btn-success button_blue pl-4 pr-4"
                            >
                              Update Salary
                            </button>
                            <button
                              onClick={() => show(false)}
                              class="btn_padding_left btn btn-danger btn_width  pl-4 pr-4 ml-3"
                            >
                              Cancel
                            </button>
                          </div>
                        </>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditDefineSallary;
